import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';
import {
  NewUsersResponse,
  ActiveUsersResponse,
  UniqueSendersResponse,
  ReferralTrafficResponse,
  CardsAddedResponse,
  AnalyticsPeriod
} from 'types/interfaces/admin/analytics';

export const analyticsApi = createApi({
  reducerPath: 'analyticsApi',
  baseQuery: baseQuery,
  tagTypes: ['Analytics'],
  endpoints: (builder) => ({
    getNewUsers: builder.query<NewUsersResponse, { period: AnalyticsPeriod }>({
      query: ({ period }) => ({
        url: `/admin/analytics/new-users?period=${period}`,
        method: 'GET',
        requiresAuth: true,
      }),
      providesTags: ['Analytics'],
    }),
    getActiveUsers: builder.query<ActiveUsersResponse, { period: AnalyticsPeriod }>({
      query: ({ period }) => ({
        url: `/admin/analytics/active-users?period=${period}`,
        method: 'GET',
        requiresAuth: true,
      }),
      providesTags: ['Analytics'],
    }),
    getUniqueSenders: builder.query<UniqueSendersResponse, { period: AnalyticsPeriod }>({
      query: ({ period }) => ({
        url: `/admin/analytics/unique-senders?period=${period}`,
        method: 'GET',
        requiresAuth: true,
      }),
      providesTags: ['Analytics'],
    }),
    getReferralTraffic: builder.query<ReferralTrafficResponse, { period: AnalyticsPeriod }>({
      query: ({ period }) => ({
        url: `/admin/analytics/referral-traffic?period=${period}`,
        method: 'GET',
        requiresAuth: true,
      }),
      providesTags: ['Analytics'],
    }),
    getCardsAdded: builder.query<CardsAddedResponse, { period: AnalyticsPeriod }>({
      query: ({ period }) => ({
        url: `/admin/analytics/cards-added?period=${period}`,
        method: 'GET',
        requiresAuth: true,
      }),
      providesTags: ['Analytics'],
    }),
  }),
});

export const {
  useGetNewUsersQuery,
  useGetActiveUsersQuery,
  useGetUniqueSendersQuery,
  useGetReferralTrafficQuery,
  useGetCardsAddedQuery
} = analyticsApi;
